import { getAxiosInstance } from "../../apis";

// Asks Laravel to create a Checkout.com PaymentSession for this order.
// Returns the session object the Flow SDK mounts against — it must carry at
// least `id` and `payment_session_secret`. Errors are thrown so the caller can
// tell "session failed" apart from "session created but empty".
export const createPaymentSession = async (params) => {
  const api = await getAxiosInstance();
  const response = await api.post("/create-payment-session", params);
  return response.data;
};

export const validateURLSession = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post("/apple-pay-session", params);
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const apple_pay = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post("/apple-pay", params);
    return response;
  } catch (error) {
    return error.response.data;
  }
};
